import { SALON } from "@/data/content";

const ABSCHNITTE = [
  {
    title: "1. Verantwortliche Stelle",
    text: `Verantwortlich für die Datenverarbeitung auf dieser Website ist: ${SALON.name}, Nezahat Ulupinar, ${SALON.street}, ${SALON.city}, Telefon: ${SALON.phoneDisplay}, E-Mail: nezahatozan62@gmail.com.`,
  },
  {
    title: "2. Welche Daten wir verarbeiten",
    text: "Wenn Sie uns über das Termin-, Kontakt- oder Bewerbungsformular schreiben, verarbeiten wir die von Ihnen angegebenen Daten (Name, Telefonnummer, gewünschte Leistung, Nachricht) ausschließlich zur Bearbeitung Ihrer Anfrage bzw. Bewerbung (Art. 6 Abs. 1 lit. b DSGVO). Eine Weitergabe an Dritte erfolgt nicht.",
  },
  {
    title: "3. Cookies",
    text: "Diese Website verwendet nur technisch notwendige Cookies bzw. Speicher-Einträge, z. B. um Ihre Cookie-Auswahl zu speichern. Ein Tracking zu Werbezwecken findet nicht statt.",
  },
  {
    title: "4. Google Maps",
    text: "Die Kartenansicht von Google Maps wird erst geladen, wenn Sie aktiv zustimmen. Beim Laden werden Daten (z. B. Ihre IP-Adresse) an Google übertragen. Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.",
  },
  {
    title: "5. Speicherdauer",
    text: "Anfragen und Bewerbungen speichern wir nur so lange, wie es für die Bearbeitung erforderlich ist. Bewerbungsdaten löschen wir spätestens sechs Monate nach Abschluss des Verfahrens, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.",
  },
  {
    title: "6. Ihre Rechte",
    text: "Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Außerdem können Sie sich bei der zuständigen Aufsichtsbehörde beschweren (Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen).",
  },
];

export default function Datenschutz() {
  return (
    <div data-testid="page-datenschutz">
      <section className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6">
          <span className="text-xs uppercase tracking-[0.2em] text-[#B08D57] block mb-2 font-sans">Rechtliches</span>
          <h1 className="text-[clamp(32px,4vw,56px)] leading-tight mb-10">Datenschutzerklärung</h1>
          <div className="space-y-8">
            {ABSCHNITTE.map((a) => (
              <div key={a.title}>
                <h2 className="text-xl mb-3 text-[#24211D]">{a.title}</h2>
                <p className="text-xs text-[#24211D]/75 leading-relaxed font-sans">{a.text}</p>
              </div>
            ))}
            <p className="text-[11px] text-[#24211D]/50 font-sans">Stand: wird bei Veröffentlichung ergänzt. Hinweis: Diese Erklärung ersetzt keine Rechtsberatung.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
